var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{staticClass:"pg-icon-margin",style:(_vm.getStyle),attrs:{"src":_vm.getImage,"max-width":_vm.getSize,"width":_vm.getSize,"contain":""}},[_c('div',{ref:"iconName",staticStyle:{"display":"none"}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }